import React from 'react';
import { Box, Container, Typography, Paper, Stack } from '@mui/material';
import { Construction, AccessTime } from '@mui/icons-material';

interface ComingSoonProps {
  title?: string;
  message?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ 
  title = 'Coming Soon', 
  message = 'This feature is currently under development and will be available soon.'
}) => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          py: 4,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 6,
            textAlign: 'center',
            borderRadius: 3,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            width: '100%',
          }}
        >
          <Stack spacing={3} alignItems="center">
            <Box
              sx={{
                p: 3,
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Construction sx={{ fontSize: 48 }} />
            </Box>
            
            <Typography variant="h3" component="h1" fontWeight="bold">
              {title}
            </Typography>
            
            <Typography variant="h6" sx={{ opacity: 0.95, maxWidth: 400 }}>
              {message}
            </Typography>
            
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mt: 2,
                p: 2,
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderRadius: 2,
              }}
            >
              <AccessTime />
              <Typography variant="body1">
                Check back later for updates
              </Typography>
            </Box>
          </Stack>
        </Paper>
      </Box>
    </Container>
  );
};

export default ComingSoon;